import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface FieldGroupSurfaceProps {
  children: ReactNode;
  className?: string;
}

export function FieldGroupSurface({
  children,
  className,
}: FieldGroupSurfaceProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-neutral-100 bg-white p-5 shadow-sm sm:p-6",
        className
      )}
    >
      {children}
    </div>
  );
}
